"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumDepositorProxy = void 0;
const address_1 = require("./address");
const bridge_1 = require("./bridge");
/**
 * Abstract class representing a depositor proxy contract on Ethereum.
 * It implements some common logic that is meant to facilitate creation
 * of concrete depositor proxy handles for Ethereum.
 * @see {DepositorProxy} for reference.
 */
class EthereumDepositorProxy {
    constructor(address) {
        if (typeof address === "string") {
            this.address = address_1.EthereumAddress.from(address);
        }
        else {
            this.address = address;
        }
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {DepositorProxy#getChainIdentifier}
     */
    getChainIdentifier() {
        return this.address;
    }
    /**
     * Packs deposit parameters to match the ABI of the revealDeposit and
     * revealDepositWithExtraData functions of the Ethereum Bridge contract.
     * @param depositTx - Deposit transaction data
     * @param depositOutputIndex - Index of the deposit transaction output that
     *        funds the revealed deposit
     * @param deposit - Data of the revealed deposit
     * @param vault - Optional parameter denoting the vault the given deposit
     *        should be routed to
     * @returns Packed parameters.
     * @protected
     */
    packRevealDepositParameters(depositTx, depositOutputIndex, deposit, vault) {
        return (0, bridge_1.packRevealDepositParameters)(depositTx, depositOutputIndex, deposit, vault);
    }
}
exports.EthereumDepositorProxy = EthereumDepositorProxy;
//# sourceMappingURL=depositor-proxy.js.map